var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4062 2.80078C8.84766 2.80078 7.61719 1.84375 5.70312 1.84375C4.9375 1.84375 4.22656 2.00781 3.59766 2.25391C3.70703 1.43359 3.05078 0.722656 2.25781 0.777344C1.57422 0.777344 1.02734 1.32422 1 2.00781C0.945312 2.60938 1.32812 3.12891 1.875 3.32031V14.4219C1.875 14.6133 2.01172 14.75 2.20312 14.75H2.42188C2.58594 14.75 2.75 14.6133 2.75 14.4219V11.1133C3.59766 10.7031 4.71875 10.3203 6.44141 10.3203C8 10.3203 9.23047 11.2773 11.1445 11.2773C12.5391 11.2773 13.6602 10.7852 14.6992 10.1016C14.8906 9.96484 15 9.77344 15 9.55469V2.39062C15 1.89844 14.4805 1.59766 14.043 1.78906C13.0586 2.25391 11.6914 2.80078 10.4062 2.80078ZM2.3125 1.51562C2.61328 1.51562 2.85938 1.76172 2.85938 2.0625C2.85938 2.39062 2.61328 2.60938 2.3125 2.60938C1.98438 2.60938 1.76562 2.39062 1.76562 2.0625C1.76562 1.76172 1.98438 1.51562 2.3125 1.51562ZM14.125 9.44531C13.4688 9.91016 12.3477 10.375 11.1445 10.375C9.39453 10.375 8.19141 9.44531 6.44141 9.44531C5.18359 9.44531 3.65234 9.71875 2.75 10.1562V3.67578C3.37891 3.21094 4.5 2.71875 5.70312 2.71875C7.45312 2.71875 8.65625 3.67578 10.4062 3.67578C11.6641 3.67578 13.1953 3.15625 14.125 2.71875V9.44531Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.d4529a01.svg";
export { ForwardRef as ReactComponent };